import api from './api';

export interface CustomerPayment {
  id: string;
  transferId: string;
  customerId: string;
  amount: number;
  paymentDate: string;
  paymentMethod: string;
  notes?: string;
  createdAt: string;
  transfer?: any;
  customer?: any;
  recordedBy?: any;
}

export interface CreateCustomerPaymentDto {
  transferId?: string;
  customerId: string;
  amount: number;
  paymentDate: string;
  paymentMethod?: string;
  notes?: string;
}

export interface CustomerPaymentSummary {
  customerId: string;
  customerName: string;
  totalAmount: number;
  totalPaid: number;
  totalPending: number;
  transferCount: number;
  paidTransferCount: number;
  pendingTransferCount: number;
  paymentMode?: string;
  balance?: number;
}

export interface TransferPaymentDetails {
  transfer: {
    id: string;
    transferCode?: string;
    transferDate: string;
    pickupLocation: string;
    dropoffLocation: string;
    customerPrice: number;
    customerName: string;
  };
  totalPrice: number;
  totalPaid: number;
  remaining: number;
  payments: CustomerPayment[];
}

class CustomerPaymentsService {
  async create(data: CreateCustomerPaymentDto): Promise<CustomerPayment> {
    const response = await api.post('/customer-payments', data);
    return response.data;
  }

  async getAll(filters?: {
    customerId?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<CustomerPayment[]> {
    const params = new URLSearchParams();
    if (filters?.customerId) params.append('customerId', filters.customerId);
    if (filters?.startDate) params.append('startDate', filters.startDate);
    if (filters?.endDate) params.append('endDate', filters.endDate);

    const response = await api.get(`/customer-payments?${params.toString()}`);
    return response.data;
  }

  async getSummary(filters?: {
    customerId?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<CustomerPaymentSummary[]> {
    const params = new URLSearchParams();
    if (filters?.customerId) params.append('customerId', filters.customerId);
    if (filters?.startDate) params.append('startDate', filters.startDate);
    if (filters?.endDate) params.append('endDate', filters.endDate);

    const response = await api.get(`/customer-payments/summary?${params.toString()}`);
    return response.data;
  }

  async getUnpaidTransfers(customerId: string): Promise<any[]> {
    const response = await api.get(`/customer-payments/unpaid-transfers/${customerId}`);
    return response.data;
  }

  async getTransferDetails(transferId: string): Promise<TransferPaymentDetails> {
    const response = await api.get(`/customer-payments/transfer/${transferId}`);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/customer-payments/${id}`);
  }
}

export const customerPaymentsService = new CustomerPaymentsService();
